<template>
  <div id="app" :class="[isReturnHome ? 'app-BoX' : 'app-ative']">
    <!-- 缓存类主页面 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- 主页面 -->
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- 低栏 -->
    <Tabber v-if="showTabbar" ref="tabber" />
    <!-- 客服1 -->
    <div
      id="btn_udesk_im"
      style="display:none"
      v-show="!udeskIm"
      @click="jumpKf()"
    >
      <img src="~@/assets/images/my_v2/nav_icon_kf.png" />
    </div>
    <!-- 客服2  >>> 并无判断唤起 -->
    <!-- <div class="btn_udesk_im myHelp" v-show="udeskIm2">
      <img src="~@/assets/images/my_v2/nav_icon_kf.png" />
      <p>在线客服</p>
    </div> -->
    <!-- eslint-disable -->
		<!-- 客服3 -->
		<!-- <img id="homeServiceOpacity" src="~@/assets/images/icon_v2/service.png" :class="['btn_udesk_im', 'homeIndex',grayFlag?'gray_flag':'']" v-if="udeskIm3"  @click="jumpKf()"/> -->
		<!-- 客服4 -->
		<div class="btn_udesk_im course-detail" :class="course?'btn_udesk_course':''" v-show="udeskIm4 && showCourseDetailServe"  @click="jumpKf()">
			<img src="~@/assets/images/my_v2/nav_icon_kf.png" :class="course?'btn_udesk_course_img':''" />
			<p>客服</p>
		</div>
		<!-- 客服5 -->
		<div class="btn_udesk_im course-detail" v-show="udeskIm5 && showCampDetailServe"  @click="jumpKf()">
			<img src="~@/assets/images/my_v2/nav_icon_kf.png" />
			<p>客服</p>
		</div>

		<!-- 监控返回首页 -->
		<!-- <div v-if="isReturnHome" class="floating">
			1212
		</div> -->
    <div v-if="isReturnHome" class="footer_box">
      <div class="footer_box_item">
        <img
          class="footer_box_icon"
          src="@/assets/images/GuideHome/download-icon.png"
          alt=""
        />
        <div class="footer_box_right">
          <span>稚旅</span>
          <span>家庭出行，找我就行</span>
        </div>
      </div>
      <div class="download" @click="showApp = true">立即下载</div>
    </div>
    <div class="floatingand"></div>
		<register :authShow="mixinAuthShow" @close="mixinAuthShow = false" @confirmFunc="handleReceive" />
		<!-- 绑定服务人弹窗 -->
		<!-- <van-dialog v-model="show" title="温馨提醒" show-cancel-button cancel-button-text="稍后绑定" confirm-button-text="立即绑定" confirm-button-color="#FF4040" cancel-button-color="#999999" @confirm="personconfirm" @cancel="personshow = true">
			<div class="person_box">系统检测您没有对应的服务人。绑定服务人，即可享受更及时、优质的服务。包括导师授课，问题答疑等1对1服务。</div>
		</van-dialog>
    <van-dialog v-model="personshow" title="如何绑定" confirm-button-text="我知道了" confirm-button-color="#FF4040" @confirm="LaterClick">
			<div class="person_box">您可在“我的”页面，点击“服务人”，进入页面手动绑定</div>
      <img class="person_img" src="~@/assets/images/my_v1/personStatus.png" alt="">
		</van-dialog> -->
     <!-- 绑定服务人 -->
    <!-- <div v-if="token && personFlad && userInfo.validateStatus !== 15 && ServiceShow" class="floating_person">
      <div @click="partnerurlClick"><img src="~@/assets/images/my_v1/person.png" alt=""></div>
    </div> -->
    <!-- 绑定服务人-阅读协议 -->
    <van-dialog
      v-model="dialogshow"
      title="服务人说明"
      show-cancel-button
      cancel-button-text="取消"
      confirm-button-text="确定绑定"
      confirm-button-color="#FF4040"
      cancel-button-color="#999999"
      @confirm="PartnerProtocol"
      :before-close="PartnerProtocolclose"
    >
      <div class="PartnerProtocol_box">
        <p style="margin:10px 0">
          1、查看/拨号服务人，需同意家慧库将您的联系方式显示给服务人，允许服务人电话联系，为您提供相应服务。详情请查看底部服务人协议；
        </p>
        <p style="margin-bottom:10px">
          2、你已绑定的服务人将同时在家慧库和爱自然生命力平台同时为你提供线上线下服务；
        </p>
        <p class="serviceAgreement" style="margin-bottom:10px">
          <img
            @click="CheckShow = !CheckShow"
            class="CheckIcon"
            :src="CheckShow ? Checkico : CheckNoico"
            alt=""
          />
          <span @click="PartnerProtocolClick" class="validateStatusNane">《服务人协议》</span>
        </p>
      </div>
    </van-dialog>
    <open-app v-model="showApp" />
	</div>
</template>

<script>
import Tabber from './views/tabbar'
import Camp from '@/models/camp'
import user from '@/models/user'
import { mapGetters, mapActions } from 'vuex'
import StudyRecord from '@/models/study-record'
import { setWeChatIos } from '@/utils/cookie'
import { auth } from '@/utils/mixin' //第二步
const sha1 = require('js-sha1')
const jweixin = require('jweixin-module')
import openApp from '@/components/openApp/openApp'
export default {
  mixins: [auth], // 第三步
  components: {
    Tabber,
    openApp
  },
  data() {
    return {
      grayFlag: false, // 页面置灰控制入口
      dialogshow: false,
      CheckShow: false,
      Checkico: require('@/assets/images/my_v1/Check.png'),
      CheckNoico: require('@/assets/images/my_v1/CheckNo.png'),
      handleReceive: false,
      scrolled: false, // 页面是否滚动
      udeskIm: false,
      udeskIm2: false,
      udeskIm3: true,
      udeskIm4: false,
      udeskIm5: false,
      isReturnHome: false,
      firstUrl: '',
      config: '',
      // status
      course: false, //用于控制课程页面的客服按钮高度
      show: false,
      personshow: false,
      personFlad: false,
      partnerurl: '/servicePerson',
      ServiceShow: false,
      showApp: false
    }
  },
  computed: {
    showTabbar() {
      let isApp = this.utils.isApp()
      if (isApp) {
        return false
      }
      return this.$route.meta.showTabbar
    },
    ...mapGetters([
      'userInfo',
      'homeScrollTop',
      'homeServiceOpacity',
      'token',
      'showCourseDetailServe',
      'showCampDetailServe'
    ])
  },
  watch: {
    $route(to, form) {
      if (to.path == '/') {
        window.addEventListener('scroll', this.handleScroll)
        // 当前为首页登录之后显示绑定服务人入口
        if (this.token) {
          this.personFlad = true
          user.getUserInfo().then(res => {
            if (res.data.partnerData) {
              if (res.data.whetherApplyBindPartner === 3) {
                this.partnerurl = '/AllocationRequest'
              } else {
                this.partnerurl = '/myservice'
              }
            } else {
              if (res.data.whetherApplyBindPartner === 1) {
                this.partnerurl = '/servicePerson'
              } else if (
                res.data.whetherApplyBindPartner === 2 ||
                res.data.whetherApplyBindPartner === 3
              ) {
                this.partnerurl = '/AllocationRequest'
              }
            }
          })
        } else {
          this.personFlad = false
        }
      } else if (to.path == '/my/index') {
        this.personFlad = false
        window.removeEventListener('scroll', this.handleScroll)
        window.addEventListener('scroll', this.handleMyScroll)
      } else {
        this.personFlad = false
        window.removeEventListener('scroll', this.handleScroll)
      }
      if (form.path === '/login') {
        this.getUserInfo()
      }
      // 会员Banner是否禁用分享
      if (to.fullPath.indexOf('isBannerShare=') != -1) {
        jweixin.hideOptionMenu()
      } else {
        jweixin.showOptionMenu()
      }
    }
  },

  mounted() {
    let urlIos = window.location.href
    if (urlIos.indexOf('channel=WeChatIos') != -1) {
      setWeChatIos(true)
    }
    // 获取页面置灰配置
    // user.getTurnGreyConfig().then(res => {
    //   if (res.status === 200 && res.data) {
    //     if (res.data.status === 1) {
    //       if (
    //         res.data.appType.split(',').indexOf('2') !== -1 &&
    //         res.data.pageType.split(',').indexOf('2') !== -1
    //       ) {
    //         this.grayFlag = true
    //       }
    //     }
    //   }
    // })
    if (this.token) {
      // this.seminarVip()
    }
    // 判断进入的是否是tab页面 不是就显示返回首页提示
    let isApp = this.utils.isApp()
    let arr = ['/swjjApp', '/guideHome', '/findBuddy/activityDetails']
    let index = arr.indexOf(window.location.pathname)
    this.firstUrl = window.location.pathname
    if (index === -1 && !isApp) {
      this.isReturnHome = true
    } else {
      this.isReturnHome = false
    }
    // this.handleRecord()
  },
  // 控制客服按钮开关（通过检查页面路径决定是否开启客服标签（其一））
  beforeUpdate() {
    const pathname = window.location.pathname
    if (pathname == '/my/index') {
      this.resetUdestIm()
      this.udeskIm = true
    } else if (pathname == '/my/help') {
      this.resetUdestIm()
    } else if (pathname == '/') {
      this.resetUdestIm()
      this.udeskIm3 = true
    } else if (
      pathname.indexOf('/courseDetail/') != -1 &&
      pathname != '/courseDetail/successBuy'
    ) {
      this.resetUdestIm()
      this.udeskIm4 = true
    } else if (pathname.indexOf('/camp/campDetail') != -1) {
      this.resetUdestIm()
      this.udeskIm5 = true
    } else {
      this.resetUdestIm()
    }

    // 给课程介绍页与课程详情页开启客服标签
    if (
      pathname.indexOf('/courseDetail/') != -1 ||
      pathname.indexOf('/courseDetail/detail') != -1
    ) {
      // console.log('进入了课程介绍页')
      this.resetUdestIm()
      this.course = true
      this.udeskIm4 = true
      // console.log(this.udeskIm4, this.showCourseDetailServe)
    } else {
      this.course = false
    }

    // this.kf()
    // 判断是否是否第一次进 及 是否显示返回首页提示
    if (
      this.isReturnHome === true &&
      this.firstUrl !== window.location.pathname
    ) {
      this.isReturnHome = false
    }
  },
  methods: {
    // 客服跳转
    jumpKf() {
      window.location.href = this.kfLink
    },
    PartnerProtocolClick() {
      this.dialogshow = false
      this.$router.push({
        path: '/serviceAgreement'
      })
    },
    partnerurlClick() {
      if (
        this.userInfo.partnerData &&
        this.userInfo.partnerData.protocolStatus === 0
      ) {
        this.dialogshow = true
      } else {
        this.$router.push({
          path: this.partnerurl
        })
      }
    },
    // 已阅读
    async PartnerProtocol() {
      if (!this.CheckShow) return
      let res = await user.changePartnerProtocol({ type: 1 })
      if (res.status === 200) {
        this.setInfo()
      }
    },
    // 关闭前回调
    PartnerProtocolclose(action, done) {
      if (action === 'cancel') {
        this.CheckShow = false
        done()
      } else {
        if (this.CheckShow) {
          done()
        } else {
          this.$toast({
            message: '请勾选“服务人协议”',
            position: 'bottom'
          })
          done(false)
        }
      }
    },
    resetUdestIm() {
      this.udeskIm = false
      this.udeskIm2 = false
      this.udeskIm3 = false
      this.udeskIm4 = false
      this.udeskIm5 = false
    },
    //判断是否vip
    async seminarVip() {
      const res = await Camp.seminarVip()
      if (res.status == 200) {
        const isVip = res.data
        this.setGlobalVip(isVip)
      }
    },
    //把之前课程的学习记录，发送请求（红兰解读，名门望族，微课，精品课）
    async handleRecord() {
      if (localStorage.getItem('courseData')) {
        let data = JSON.parse(localStorage.getItem('courseData'))
        const res = await StudyRecord.addStudyRecord(data)
        if (res.status == 200) {
          localStorage.removeItem('courseData')
        }
      }
    },
    handleScroll() {
      //滚动的距离
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > this.homeScrollTop) {
        this.setHomeScrollTop(scrollTop)
        document.getElementById('homeServiceOpacity').style.opacity = '0.5'
      } else {
        document.getElementById('homeServiceOpacity').style.opacity = '1'
        this.setHomeScrollTop(scrollTop)
      }
    },
    kf() {
      /* eslint-disable */
			if (this.userInfo) {
				let nonce = this.randomString(13)
				let timestamp = new Date().getTime()
				let sign_str =
					'nonce=' +
					nonce +
					'&timestamp=' +
					timestamp +
					'&web_token=' +
					this.userInfo.id +
					'&1c754a7d7b8debd47a403bcf3d76e224'
				sign_str = sha1(sign_str)
				sign_str = sign_str.toUpperCase();
				(function (a, h, c, b, f, g) {
					a['UdeskApiObject'] = f
					a[f] =
						a[f] ||
						function () {
							(a[f].d = a[f].d || []).push(arguments)
						}
					g = h.createElement(c)
					g.async = 1
					g.charset = 'utf-8'
					g.src = b
					c = h.getElementsByTagName(c)[0]
					c.parentNode.insertBefore(g, c)
				})(
					window,
					document,
					'script',
					'https://assets-cli.s2.udesk.cn/im_client/js/udeskApi.js',
					'ud'
				)
				ud({
					code: 'jfhd1ad',
					link: 'https://jhk.s2.udesk.cn/im_client/?web_plugin_id=19842',
					isInvite: true,
					mode: 'blank',
					color: '#c3a886',
					targetSelector: '#btn_udesk_im',
					selector: '.btn_udesk_im',
					css: {
						bottom: '15%',
						right: '10%',
					},
				})
				ud({
					customer: {
						c_name: this.userInfo.nickname,
						c_phone: this.userInfo.mobile,
						c_vip: this.userInfo.validateStatus != 0 ? 'vip' : 'normal',
						c_cf_身份: this.userInfo.validateStatus,
						c_cf_省中心: this.userInfo.prov_brach,
						c_cf_ID: this.userInfo.id,
						nonce: nonce,
						signature: sign_str,
						timestamp: timestamp,
						web_token: this.userInfo.id,
					},
				})
			}
			/* eslint-disable */
		},
		randomString (len = 32) {
			var $chars =
				'abcdefhijkmnprstwxyz2345678' /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
			var maxPos = $chars.length
			var pwd = ''
			for (let i = 0; i < len; i++) {
				pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
			}
			return pwd
		},
		// 获取用户信息判断是否需要弹窗绑定服务人员
		async getUserInfo () {
      if (this.token) {
        let Person = await user.getPartnerFunction({type:''})
        if (Person.data.data.indexOf('bindPartnerFunctionV2') !== -1) {
          // 显示服务人
          this.ServiceShow = true
          let res = await user.getUserInfo()
				  if (res.status === 200 && res.data.validateStatus !== 15) {
				  	if (!res.data.partnerData && res.data.whetherApplyBindPartner === 1) {
              if(this.utils.isWeiXin()) {
                this.show = true
              }
				  	}
				  }
        } else {
          // 隐藏服务人
          this.ServiceShow = false
        }
        
      }
     
		},
    // 重新设置用户信息
    async setInfo() {
      let res = await user.getUserInfo()
       if (res.status === 200) {
        this.setUserInfo(res.data)
      }
    },
		// 立即绑定
		personconfirm () {
      this.$router.push({
        path: `/servicePerson`
      })
		},
    // 服务人二次弹窗
    LaterClick() {
      if (window.location.pathname === '/') {
        this.personFlad = true
      }
    },
		...mapActions([
			'setHomeScrollTop',
			'setHomeServiceOpacity',
			'setGlobalVip',
      'setUserInfo'
		]),
	},
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/global.less';
.footer_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 144 / @r;
  background-color: #fff;
  padding: 24 / @r 32 / @r;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px -2 / @r 0px 0px #ebeef5;
  z-index: 1;
  .footer_box_item {
    display: flex;
    align-items: center;
    background-color: #fff;
    flex: 1;
    .footer_box_icon {
      width: 96 / @r;
      height: 96 / @r;
      border-radius: 16 / @r;
    }
    .footer_box_right {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 10 / @r;
      font-size: 24 / @r;
      color: #909399;
      span:first-child {
        font-size: 32 / @r;
        font-weight: bold;
        color: #28cb89;
      }
    }
  }
  .download {
    background: linear-gradient(133deg, #28cb89 0%, #6ae793 100%);
    border-radius: 53 / @r;
    width: 192 / @r;
    height: 72 / @r;
    font-weight: bold;
    font-size: 28 / @r;
    color: #ffffff;
    text-align: center;
    line-height: 72 / @r;
  }
}
.floating {
	position: fixed;
	bottom: 0;
	left: 0;
	background: #94252a;
	width: 100%;
	margin: 0;
	z-index: 1999;
}
#btn_udesk_im {
	display: none;
}
// #btn_udesk_im {
//   position: fixed;
//   z-index: 2;
//   right: 0;
//   top: 0;
//   padding: 20 / @r 30 / @r;
//   margin-top: 730/@r;
//   margin-right: 61/@r;
//   // img {
//   //   width: 48 / @r;
//   //   height: 45 / @r;
//   // }
//   background: #fff;
// }
.myHelp {
	position: fixed;
	bottom: 20 / @r;
	left: 5%;
	width: 90%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #fff;
	img {
		width: 50 / @r;
		height: 50 / @r;
	}
}
.course-detail {
	position: fixed;
	left: 3.73%;
	bottom: 10 / @r;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	img {
		width: 50 / @r;
		height: 50 / @r;
	}
	p {
		margin: 0;
		margin-top: 4 / @r;
		font-size: 20 / @r;
		line-height: 20 / @r;
		color: #000;
	}
}
.homeIndex {
	position: fixed;
	bottom: 200 / @r;
	right: 0;
	width: 140 / @r;
	margin: 0;
	z-index: 1999;
	border-radius: 50%;
}
.gray_flag {
  -webkit-filter: grayscale(1); /* Webkit */
  filter: gray; /* IE6-9 */
  filter: grayscale(1);
}
</style>

<style lang="less" scoped>
@import '~@/assets/styles/global.less';
.app-BoX{
  position: relative;
  padding-bottom: 144 /@r;
}
.app-ative{
  padding-bottom: 0 /@r !important;
}
.PartnerProtocol_box {
  padding: 0 30 / @r;
  padding-bottom: 20 / @r;
  p {
    margin-bottom: 0;
    font-size: 28 / @r;
  }
}
.serviceAgreement {
  display: flex;
  align-items: center;
  height: 30 / @r;
}
.CheckIcon {
  width: 30 / @r;
  height: 30 / @r;
  padding-right: 10 / @r;
}
.validateStatusNane {
  color: #277fe0;
  font-size: 28 / @r;
}
.btn_udesk_course {
	p {
		font-size: 22 / @r !important;
		color: #333;
	}
	.btn_udesk_course_img {
		padding-bottom: 2px;
	}
}
.person_box {
	padding: 40 / @r 50 / @r;
	text-align: center;
}
.person_img{
  display: block;
  width: 600 / @r;
  height: 140px;
  margin: 0 auto;
  margin-bottom: 10px;
}
// 服务人
.floating_person {
  position: fixed;
  bottom: 340 / @r;
  right: 0;
  z-index: 1999;
  width: 116 / @r;
  height: 88 / @r;
  img {
    width: 94 / @r;
    height: 88 / @r;
  }
}
</style>
